@import 'src/client/view/style/constants.scss';

.container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
}
